/*global vdomVirtualize, virtualDom */


export function getVNodeFromHMTL(html) {
	return convertHTML(html);
}

export function setupMixins() {
	_.mixin({
		deepPluck: (obj, path) => {
			if (_.isString(path)) {
				path = path.split(".")
			}
			return _.reduce(path, function pluck(ret, ident) {
				if (ident === "*") {
					for (var key in ret) {
						if (ret.hasOwnProperty(key)) {
							return ret[key];
						}
					}
				}
				return ret[ident];
			}, obj);
		}
	});
}
setupMixins();
export function delegate(wrapper, selector, eventNames) {
	return Rx.Observable.from(eventNames.split(",")).mergeMap(eventName => {
		return Rx.Observable.fromEvent(
			wrapper,
			eventName.replace(/\s/g, ""),
			function (e) {
				return {event: e, delegate: e.target.closest(selector)};
			});
	}).filter(function (x) {
		return x.delegate !== null;
	});
}

export function convertName(s, spaceReplacer = "_") {
	return s.toLowerCase().replace(/"/g, '').replace(/\s/g, spaceReplacer);
}

export function getFile(url) {
	// get image mapping file for Interior viewer and update store
	let p = new Promise(function (resolve, reject) {
		$.ajax({
			url: url
		}).done(function (map) {
			resolve(map);
		}).fail(function (e) {
			reject("failed to get interior map", e);
		});
	});
	return p;
}

export function getFabs(state, all) {
	let fabData, fabs,
		truckName = "Cascadia-" + state.truckCab;
	// get the id of the current pillar for the current truck
	try{
		if (!state.pathTree.FTL.Truck[truckName].Explore[_.capitalize(state.view)]) {
			
			return [];
		}		
	}catch(error){
		window.___state_err = {state,path:'state.pathTree.FTL.Truck', truckName};
	}


	if (all) {
		// get all the fab ids for the truck regardless of pillar
		fabData = _.chain(state.pathTree)
			.deepPluck("FTL.Truck." + truckName + ".Explore." + _.capitalize(state.view))
			.map((pillar, pillarKey) => {
				return _.chain(pillar).map((xNode, key) => {
					let x = parseInt(key, 10);
					return _.chain(xNode).map((yNode, key) => {
						return {
							"pillar": pillarKey,
							"id": yNode.id,
							"fabPosition": {
								radius: state.interiorViewRadius,
								// lat/phi -90 to 90
								lat: x,
								// lon/theta -180 to 180
								lon: parseFloat(key, 10)
							}
						}
					}).flatten().value();
				}).flatten().value();
			}).flatten().value();
	} else {
		// get all the fab ids filtered by truck and current pillar
		fabData = _.chain(state.pathTree)
			.deepPluck("FTL.Truck." + truckName + ".Explore." + _.capitalize(state.view) + "." + state.pillar)
			.map((xNode, key) => {
				let x = parseInt(key, 10);
				return _.chain(xNode).map((yNode, key) => {
					if (state.view === "exterior") {
						return {
							"pillar": state.pillar,
							"id": yNode.id,
							"fabPosition": {
								x: x,
								y: parseInt(key, 10)
							}
						}
					}
					return {
						"pillar": state.pillar,
						"id": yNode.id,
						"fabPosition": {
							radius: state.interiorViewRadius,
							// lat/phi -90 to 90
							lat: x,
							// lon/theta -180 to 180
							lon: parseFloat(key, 10)
						}
					}
				}).flatten().value();
			}).flatten().value();
	}
	// console.log(fabData, _.deepPluck(state.pathTree, "FTL.Truck." + truckName + ".Explore.Exterior." + state.pillar));

	// filter the fabs by the ids gathered above
	fabs = _.chain(state.adsFabs).filter((fab) => {
		return _.some(fabData, fabInfo => {
			return _.includes(fab.nodes, fabInfo.id)
		});
	})
	// combine the fabs with the info gathered above
		.map((fab, i) => {
			let fabInfo = _.chain(fabData).filter(fabInfo => {
					return _.includes(fab.nodes, fabInfo.id);
				}).value()[0],
				additionalData = {
					fabPosition: fabInfo.fabPosition,
					pillar: fabInfo.pillar,
					index: i,
					assets: false
				},
				assetNode = _.chain(state.pathTree)
					.deepPluck("FTL.Asset." + fab.id).value(),
				assetNodeId = assetNode && assetNode.id,
			// combine the fab with other assets like videos
			assets = _.chain(state.adsVids).filter(vid => {
				return _.includes(vid.nodes, assetNodeId);
			}).value();

			if (assets.length > 0) {
				additionalData.assets = assets;
			}

			return Object.assign({}, fab, additionalData);
		}).value();
	// console.log("fabs", fabs);
	return fabs;
}

export function getHashParameter(parameterName) {
	var hash = window.location.hash,
		re = new RegExp("[#&]" + parameterName + "=([\\w-]+)", "gi"),
		parameter = re.exec(hash) || [null, ''];
	return parameter[1];
}

export function getUrlParams(url) {
	var re = /(?:\#|&(?:amp;)?)([^=&#]+)(?:=?([^&#]*))/g,
		match, params = {},
		decode = function (s) {return decodeURIComponent(s.replace(/\+/g, " "));};

	if (typeof url == "undefined") url = document.location.href;

	while (match = re.exec(url)) {
		params[decode(match[1])] = decode(match[2]);
	}
	return params;
}


export function updateHashParameters(params) {
	if (!params) {
		window.location.hash = "";
	} else if (_.isObject(params)) {
		let currentParams = getUrlParams(),
			newParams = Object.assign({}, currentParams, params);
		window.location.hash = _.chain(newParams).map((v, k) => k + "=" + v).value().join("&");
	}
}


// element-closest | CC0-1.0 | github.com/jonathantneal/closest
if (typeof Element.prototype.matches !== 'function') {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.webkitMatchesSelector || function matches(selector) {
			var element = this;
			var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
			var index = 0;

			while (elements[index] && elements[index] !== element) {
				++index;
			}

			return Boolean(elements[index]);
		};
}
if (typeof Element.prototype.closest !== 'function') {
	Element.prototype.closest = function closest(selector) {
		var element = this;

		while (element && element.nodeType === 1) {
			if (element.matches(selector)) {
				return element;
			}

			element = element.parentNode;
		}

		return null;
	};
}
// end element-closest polyfill